import { gql } from '@apollo/client'

export const initiateInvestmentTransfer = gql`
  mutation InitiateInvestmentTransfer($input: InitiateInvestmentTransferInput!) {
    initiateInvestmentTransfer(input: $input) {
      id
      amount
      currentStep
    }
  }
`
